import { Store } from '@/store/mainStore';
import {
	ProfileService,
	SessionStatusEnum,
	StoreService,
	UserBaseData,
	Store as StoreAPI,
	OrderService,
	AddUserToSiteInput
} from '@/store/engine/openapi/generated';
import EngineModule from '@/store/engine/modules/EngineModule';
import { action, observable } from 'mobx';

export default class StoreModule extends EngineModule {
	@observable chosenStore?: StoreAPI;

	@observable currentDevice: any = { deviceTag: '', name: '', type: null, status: null, deviceID: '' };
	@observable doctors: UserBaseData[] = [];

	constructor(s: Store) {
		super(s);
	}

	public async getDoctorsByStoreCache() {
		const doctorsList = await this.getDoctorsByStore(0, 10000);

		if (!doctorsList) throw new Error('No doctors fetched');

		this.doctors = doctorsList.users;
	}

	@action
	async setDevice(device) {
		this.currentDevice = device;
	}

	public get getStore() {
		if (this.chosenStore) {
			return this.chosenStore;
		}

		throw new Error('No store assigned');
	}

	@action
	public async setStore(storeID: string) {
		let storeFromServer = await StoreService.storeControllerStore(storeID);
		this.chosenStore = storeFromServer;
	}

	public async getEmployeeStores() {
		const employeeID = this.store.engine.auth.token?.parsedToken.user_id;
		if (!employeeID) {
			throw new Error('No known Employee');
		}
		return await StoreService.storeControllerEmployeeStores(employeeID);
	}

	public async getPatient(patientID: string) {
		return await ProfileService.profileControllerGetPatient(patientID);
	}

	public async getPatients(offset: number, limit: number, eventTypes?: SessionStatusEnum[]) {
		if (!eventTypes) {
			eventTypes = [
				SessionStatusEnum.SESSION_STATUS_SESSION_CREATED,
				SessionStatusEnum.SESSION_STATUS_MEASUREMENT_DATA_CAPTURED,
				SessionStatusEnum.SESSION_STATUS_ORDER_CREATED,
				SessionStatusEnum.SESSION_STATUS_ORDER_CANCELLED,
				SessionStatusEnum.SESSION_STATUS_ORDER_DELIVERED,
				SessionStatusEnum.SESSION_STATUS_PRESCRIPTION_COMPLETED,
				SessionStatusEnum.SESSION_STATUS_PRESCRIPTION_CREATED,
				SessionStatusEnum.SESSION_STATUS_PRESCRIPTION_UPDATED,
				SessionStatusEnum.SESSION_STATUS_REPAIR_ORDER_CREATED
			];
		}

		return await ProfileService.profileControllerGetPatients(this.getStore.storeID, this.getStore.companyID, eventTypes, offset, limit);
	}

	public async getOrderList(limit: number = 500, offset: number = 0) {
		return await OrderService.orderControllerGetOrders(this.getStore.storeID, offset, limit);
	}

	public async getDoctorsByStore(offset: number, limit: number, siteID?: string) {
		return StoreService.storeControllerGetDoctors(siteID ? siteID : this.getStore.storeID, this.store.engine.store.getStore.companyID, offset, limit);
	}

	public async addUserToSite(userID: string) {
		return await ProfileService.profileControllerAddUserToSite({
			userID: userID,
			storeID: this.getStore.storeID
		} as AddUserToSiteInput);
	}
}
